import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { StyledBadge } from '../shared/SharedStyles/Badge.Style';

const PhaseBadge = ({ small, className }) => {
  const { isTestCreatedForPhase, phaseOrder } = useSelector(
    state => ({
      isTestCreatedForPhase: state.test.is_test_created_for_phase,
      phaseOrder: state.test.phase_order,
    }),
    shallowEqual
  );

  if (!isTestCreatedForPhase) return <></>;

  return (
    <StyledBadge
      className={`${small ? 'small-badge' : ''} ${className ?? ''} `}
    >
      Phase {phaseOrder}
    </StyledBadge>
  );
};

export default PhaseBadge;
